import isArray from 'lodash-es/isArray'
import isBoolean from 'lodash-es/isBoolean'
import isObject from 'lodash-es/isObject'
import isString from 'lodash-es/isString'

/**
 * Check is variable empty.
 * We don't use lodash isEmpty functions because of it returns true for integers
 * @param value
 */
export function isEmpty<T = unknown>(value: T): boolean {
  if (value == null) {
    return true
  }

  if (isArray(value) || isString(value)) {
    return value.length === 0
  }

  if (value instanceof Map || value instanceof Set) {
    return value.size === 0
  }

  if (isObject(value)) {
    return Object.keys(value).length === 0
  }

  return false
}

/**
 * @description Checks incoming date is valid or not.
 * If incoming date has a timestamp, the date is valid. Otherwise, it is invalid.
 * @param date
 */
export function isValidDate(date?: string) {
  if (!date) return false

  const timeStamp = new Date(date).getTime()

  // If timeStamp is a number, the date is valid. If not, it is invalid.
  return !Number.isNaN(timeStamp)
}

/**
 * @method isOdd
 * @param index {number}
 * @description Does computation to determine index is odd or not.
 */
export function isOdd(index: number) {
  return index % 2 === 1
}

/**
 * @method isNumerable
 * @description Checks whether the corresponding value is numerable.
 * @example
 * Input      |     Output
 * ''         -->   false
 * 'example'  -->   false
 * null       -->   false
 * undefined  -->   false
 * true       -->   false
 * false      -->   false
 * '0'        -->   true
 * 0          -->   true
 * @param value
 */
export function isNumerable(value: any): boolean {
  return !isEmpty(value) && !isBoolean(value) && !Number.isNaN(Number(value))
}
